var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97 12.9201C2.67476 13.0975 2.43033 13.3481 2.26039 13.6477C2.09045 13.9473 2.00075 14.2857 2 14.6301V17.8701C2.00075 18.2146 2.09045 18.5529 2.26039 18.8525C2.43033 19.1521 2.67476 19.4027 2.97 19.5801L5.97 21.3801C6.28106 21.567 6.63711 21.6657 7 21.6657C7.36289 21.6657 7.71894 21.567 8.03 21.3801L12 19.0001V13.5001L7 10.5001L2.97 12.9201Z",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 16.5001L2.26001 13.6501",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5001L12 13.5001",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5001V21.6701",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5001V19.0001L15.97 21.3801C16.2811 21.567 16.6371 21.6657 17 21.6657C17.3629 21.6657 17.7189 21.567 18.03 21.3801L21.03 19.5801C21.3252 19.4027 21.5697 19.1521 21.7396 18.8525C21.9096 18.5529 21.9992 18.2146 22 17.8701V14.6301C21.9992 14.2857 21.9096 13.9473 21.7396 13.6477C21.5697 13.3481 21.3252 13.0975 21.03 12.9201L17 10.5001L12 13.5001Z",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5001L12 13.5001",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5001L21.74 13.6501",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5001V21.6701",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 4.42009C7.67476 4.59747 7.43033 4.84809 7.26039 5.14768C7.09045 5.44727 7.00075 5.78566 7 6.13009V10.5001L12 13.5001L17 10.5001V6.13009C16.9992 5.78566 16.9096 5.44727 16.7396 5.14768C16.5697 4.84809 16.3252 4.59747 16.03 4.42009L13.03 2.62009C12.7189 2.43321 12.3629 2.33447 12 2.33447C11.6371 2.33447 11.2811 2.43321 10.97 2.62009L7.97 4.42009Z",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.00015L7.26001 5.15015",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.00015L16.74 5.15015",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5001V8.00012",
    stroke: "#FF8000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/InventoryIcon.43a54b2398f5a81b3d34eb93af19ce34.svg";
export { ForwardRef as ReactComponent };